import {SET_POSTNUM} from "./types";
const actions = {
    setPostNum: ({commit}, num) => {
        commit(SET_POSTNUM, num)
    },
}
export default actions